<template>
	<div class="page">
		<div class="content">
			<!-- 返回按钮 -->
			<div class="goBack f-r-ss">
				<div class="goBack-btn f-r-sc" @click="goBack">
					<Icon type="double-left" :style="{ fontSize: '28px', marginRight: '4px' }" />
					返回
				</div>
			</div>

			<!-- 导航栏 -->
			<div class="nav">
				<div :class="['nav-item', navIndex == 0 ? 'nav-select' : '']">信息认证</div>
				<div :class="['nav-item', navIndex == 1 ? 'nav-select' : '']">创建用户</div>
				<div :class="['nav-item', navIndex == 2 ? 'nav-select' : '']">注册完成</div>
			</div>

			<!-- 表单 -->
			<div class="f-c-sc" v-show="navIndex == 0">
				<div class="form">
					<Spin :spinning="confirmLoading">
						<FormModel ref="ruleForm1" :model="form1" :rules="rules1" :label-col="{ span: 9 }" :wrapper-col="{ span: 15 }">
							<FormItem label="企业名称" prop="firmName">
								<div class="inputContent">
									<Input autocomplete="off" placeholder="请输入企业名称" @focus="showOption = true" @change="onSearch" v-model="form1.firmName" />
									<div class="dataSourse" v-if="showOption">
										<div class="dataSourse-option" :title="item.firmName" v-for="item in result" :key="item.id" @click="selectOption(item)">
											{{ item.firmName }}
										</div>
									</div>
								</div>

								<!-- <Select :style="{ width: '100%', height: '40px' }" placeholder="请输入企业名称" show-search v-decorator="[
                                        'firmName',
                                        { rules: [{ required: true, message: '请输入企业名称' }] }
                                    ]" :filter-option="false" @search="firmSearch" @change="firmChange">
									<Option v-for="item in firmList" :key="item.id" :value="item.id">
										{{ item.firmName }}
									</Option>
								</Select> -->
                                
								<!-- <a-button @click="edit" type="primary" icon="plus"></a-button> -->
							</FormItem>
							<FormItem label="所属行业" prop="involved">
								<Select :style="{ width: '100%' }" placeholder="请选择所属行业" show-search :filter-option="false" @search="busSearch" @change="busChange" v-model="form1.involved">
									<Option v-for="item in busList" :key="item" :value="item">
										{{ item }}
									</Option>
								</Select>
							</FormItem>
							<FormItem label="企业类型" prop="sort">
								<Select :style="{ width: '100%' }" placeholder="请选择企业类型" show-search :filter-option="true" v-model="form1.sort">
									<Option v-for="item in qiye_arr" :key="item.id" :value="item.id">
										{{ item.name }}
									</Option>
								</Select>
							</FormItem>
							<FormItem label="统一社会信用代码" prop="creditCode">
								<Input placeholder="请输入统一社会信用代码" v-model="form1.creditCode" />
							</FormItem>
							<FormItem label="法定代表人" prop="firmHuman">
								<Input placeholder="请输入法定代表人" v-model="form1.firmHuman" />
							</FormItem>
							<FormItem label="法定代表人身份证号码" prop="idCard">
								<Input placeholder="请输入法定代表人身份证号码" v-model="form1.idCard" />
							</FormItem>
							<FormItem label="营业收入(近1年)" prop="turnover">
								<Select placeholder="请选择营业收入" v-model="form1.turnover">
									<Option :value="item.value" v-for="(item, index) in turOption" :key="item.value">
										{{ item.label }}
									</Option>
								</Select>
							</FormItem>
							<FormItem label="注册地（高新区）" prop="izHigh">
								<Select placeholder="请选择是否高新区注册地" v-model="form1.izHigh">
									<Option value="是">
										是
									</Option>
									<Option value="否">
										否
									</Option>
								</Select>
							</FormItem>
							<FormItem label="注册资金" prop="fundMoney">
								<Select placeholder="请选择注册资金" v-model="form1.fundMoney">
									<Option :value="item.value" v-for="(item, index) in dictOptions" :key="item.value">
										{{ item.label }}
									</Option>
								</Select>
							</FormItem>
							<FormItem label="从业人数(近1年)" prop="employees">
								<Input placeholder="请输入从业人数" v-model="form1.employees" />
							</FormItem>
							<FormItem label="纳税金额(近1年)" prop="yearTax">
								<Select placeholder="请选择纳税金额" v-model="form1.yearTax">
									<Option :value="item.value" v-for="(item, index) in turOption" :key="item.value">
										{{ item.label }}
									</Option>
								</Select>
							</FormItem>

							<!-- setTime -->

							<FormItem label="营业执照注册时间" prop="setTime">
								<DatePicker style="width: 100%" v-model="form1.setTime" placeholder="请选择营业执照注册时间" />
							</FormItem>

							<FormItem label="营业执照" prop="business">
								<Upload name="file" accept="image/*" list-type="picture-card" class="avatar-uploader" :show-upload-list="false" action="https://up-z2.qiniup.com" :fileList="fileList" :data="{ token: token, key: fileName }" :before-upload="beforeUpload" @change="handleChange">
									<img v-if="form1.business" :src="form1.business" alt="avatar" class="uploadImg" />
									<div v-else>
										<Icon :type="loading ? 'loading' : 'plus'" />
										<div class="ant-upload-text">上传</div>
									</div>
								</Upload>
							</FormItem>
						</FormModel>
					</Spin>
				</div>
				<Checkbox :style="{ marginTop: '10px' }" v-model="model.checkbox">
					<span @click.stop="openFile" class="File">
						我已阅读并同意《福州高新区惠企服务平台注册协议》
					</span>
				</Checkbox>
				<Button key="next1" :style="{ marginTop: '50px', width: '220px' }" type="primary" size="large" @click="next1">下一步</Button>
			</div>
			<!-- 步骤二 -->
			<div class="f-c-sc" v-show="navIndex == 1">
				<div class="form">
					<Spin :spinning="confirmLoading">
						<FormModel ref="ruleForm2" :model="form2" :rules="rules2" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
							<FormItem label="用户昵称" prop="webName">
								<Input autocomplete="off" placeholder="请输入用户昵称" v-model="form2.webName" />
							</FormItem>
							<FormItem label="登录手机号" prop="webTel">
								<Input autocomplete="off" placeholder="请输入登录手机号" v-model="form2.webTel" />
							</FormItem>
							<FormItem label="登录密码" prop="webCode">
								<Password v-model="form2.webCode" placeholder="请输入登录密码" />
							</FormItem>
							<!-- v-decorator="[
                                        'webCode',
                                        {
                                            rules: [
                                                { required: true, message: '请输入登录密码' },
                                                {
                                                    pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/,
                                                    message: '密码由6位以上字母数字组成'
                                                }
                                            ]
                                        }
                                    ]" -->
						</FormModel>
					</Spin>
				</div>
				<Button key="next2" :style="{ marginTop: '50px', width: '220px' }" type="primary" size="large" :loading="confirmLoading" @click="register">注册</Button>
			</div>
			<!-- 步骤3 -->
			<div class="f-c-sc" v-show="navIndex == 2">
				<div class="register-success">
					<Icon type="check-circle" :style="{ marginRight: '43px' }" />
					恭喜你，注册成功
				</div>
				<Button key="next3" :style="{ marginTop: '95px', width: '220px' }" type="primary" size="large" @click="toLogin">去登录</Button>
			</div>
		</div>
	</div>
</template>

<script>
import { FormModel, Message } from "ant-design-vue";
import { getAction, postAction } from "@/util/require.js";
const FormItem = FormModel.Item;
export default {
	name: "",
	components: {
		FormModel,
		FormItem,
	},
	data() {
		return {
			navIndex: 0,
			form1: {},
			rules1: {
				firmName: [{ required: true, message: "请输入企业名称" }],
				involved: [{ required: true, message: "请选择所属行业" }],
				sort: [{ required: true, message: "请选择所属行业" }],
				creditCode: [{ required: true, message: "请输入统一社会信用代码" }],
				firmHuman: [{ required: true, message: "请输入法定代表人" }],
				idCard: [
					{ required: true, message: "请输入法定代表人身份证号码" },
					{ pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: "请输入合适身份证号码" },
				],
				turnover: [{ required: true, message: "请选择营业收入" }],
				izHigh: [{ required: true, message: "请输入注册地" }],
				fundMoney: [{ required: true, message: "请选择注册资金" }],
				employees: [{ required: true, message: "请输入从业人数" }],
				yearTax: [{ required: true, message: "请选择纳税金额" }],
				setTime: [{ required: true, message: "请选择营业执照注册时间" }],
				business: [
					// { required: true, message: "请上传营业执照" },
					// { validator: this.validateBusiness, message: "请上传营业执照" },
				],
			},

			form2: {},
			rules2: {
				webName: [{ required: true, message: "请输入用户昵称" }],
				webTel: [
					{ required: true, message: "请输入登录手机号" },
					{
						pattern: /^[1][3,4,5,7,8][0-9]{9}$/,
						message: "请输入合适的手机号",
					},
				],
				webCode: [
					{ required: true, message: "请输入登录密码" },
					{
						pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/,
						message: "密码由6位以上字母数字组成",
					},
				],
			},

			confirmLoading: false,
			result: [],
			showOption: false,

			fileList: [],
			fileName: "",
			imageUrl: "",
			loading: false,
			token: "",

			model: {},

			dictOptions: [
				{
					label: "100万以上",
					value: "100万以上",
				},
				{
					label: "300万以上",
					value: "300万以上",
				},
				{
					label: "500万以上",
					value: "500万以上",
				},
				{
					label: "1000万以上",
					value: "1000万以上",
				},
				{
					label: "2500万以上",
					value: "2500万以上",
				},
				{
					label: "5000万以上",
					value: "5000万以上",
				},
				{
					label: "1亿以上",
					value: "1亿以上",
				},
			],

			turOption: [
				{
					label: "0-50万元",
					value: "0-50万元",
				},
				{
					label: "50-100万元",
					value: "50-100万元",
				},
				{
					label: "100-200万元",
					value: "100-200万元",
				},
				{
					label: "200-500万元",
					value: "200-500万元",
				},
				{
					label: "500-1000万元",
					value: "500-1000万元",
				},
				{
					label: "1000-5000万元",
					value: "1000-5000万元",
				},
				{
					label: "5000万元以上",
					value: "5000万元以上",
				},
			],
			qiye_arr: [],

			busList: [],

			firmList: [],
		};
	},
	created() {},
	mounted() {
		this.getUploadToken();
		this.getBusList();
		this.qiye_type();
		window.addEventListener("click", this.setShowOption, false);


        this.getFirmData();
	},
	beforeDestroy() {
		window.removeEventListener("click", this.setShowOption);
	},
	methods: {
		validateBusiness(rule, value, callback) {
			console.log(rule, value, 111111111111111, callback);
			if (this.form1.business) {
				console.log(rule, value, 111111111111111);
				callback();
			} else {
				console.log(222222222222222);
				callback(new Error("请上传营业执照"));
			}
		},
		qiye_type() {
			getAction("/hq/webPage/firmSortList", {}).then((res) => {
				if (res.success) {
					this.qiye_arr = res.result;
				}
			});
		},
		setShowOption() {
			this.showOption = false;
		},
		firmSearch(e) {
			this.getFirmData(e);
		},
		firmChange(data) {
			let firm = {};
			this.firmList.forEach((item) => {
				if (item.id == data) {
					firm = item;
				}
			});
			this.form1 = firm;
		},
		getFirmData(content) {
			if (!content) return;
			let param = {};
			if (content) {
				param.content = content;
			}
			getAction("/hq/webPage/firmNameSearch", {
				...param,
			}).then((res) => {
				if (res.success) {
					this.$set(this, "firmList", res.result.slice(0, 15));
				}
			});
		},
		busChange(data) {
			console.log(data);
			this.form1.involved = data;
		},
		busSearch(e) {
			this.getBusList(e);
		},
		getBusList(content) {
			let param = {};
			if (content) {
				param.content = content;
			}
			getAction("/hq/webPage/getIndustryList", param).then((res) => {
				if (res.success) {
					this.$set(this, "busList", res.result);
				} else {
					Message.warning(res.message);
				}
			});
		},
		// 上传营业执照
		beforeUpload(file) {
			this.loading = true;
			this.fileName = "hq" + new Date().getTime() + file.name;
			return getAction("/hq/appletsLogin/getUploadToken").then((res) => {
				if (res.success) {
					this.token = res.result.token;
					return true;
				} else {
					return false;
				}
			});
		},
		handleChange(info) {
			let fileList = info.fileList;
			if (info.file.status === "done") {
				if (fileList.length > 1) {
					fileList = fileList.slice(-1);
				}
				this.loading = false;
				this.form1.business = window._CONFIG["qiniuyunUrl"] + this.fileName;
				Message.success(`${info.file.name} 上传成功!`);
			} else if (info.file.status === "error") {
				Message.error(`${info.file.name} 上传失败.`);
			} else if (info.file.status === "removed") {
			}
			this.fileList = fileList;
		},
		// 下一步 ，跳转到第二步
		next1() {
			const that = this;
			let isOk = true;

			if (this.form1.izHigh == "否") {
				Message.warning("非高新区地区不可注册");
				return;
			}
			if (!this.form1.business) {
				Message.warning("营业执照必须上传");
				return;
			}

			this.$refs.ruleForm1.validate((valid) => {
				console.log("valid", valid);
				if (valid) {
					this.model = Object.assign(this.model, this.form1);
					if (this.model.setTime && typeof this.model.setTime != "string") {
						this.model.setTime = this.model.setTime.format("YYYY-MM-DD");
					}
					this.navIndex = 1;
				}
			});
		},
		// 注册接口
		register() {
			this.$refs.ruleForm2.validate((valid) => {
				if (valid) {
					this.model = Object.assign(this.model, this.form2);
					this.confirmLoading = true;
					postAction("/hq/webPage/createWebUser", { ...this.model }).then((res) => {
						if (res.success) {
							this.navIndex = 2;
						}
						this.confirmLoading = false;
					});
				}
			});
		},
		// 查询企业
		onSearch(data) {
			getAction("/hq/webPage/firmNameSearch", {
				content: data.target.value,
			}).then((res) => {
				if (res.success) {
					if (res.result.length > 0) {
						this.showOption = true;
					}
					this.$set(this, "result", res.result.slice(0, 10));
				}
			});
		},
		// 获取七牛云 token
		getUploadToken() {
			getAction("/hq/appletsLogin/getUploadToken").then((res) => {});
		},
		selectOption(item) {
			console.log(item);
			this.form1 = item;
			this.showOption = false;
		},
		// changeNavIndex
		changeNavIndex(index) {
			this.navIndex = index;
		},
		goBack() {
			this.$router.go(-1);
		},
		toLogin() {
			this.$router.replace({ path: "/login" });
		},
		openFile() {
			window.open("https://hq-qny.laoyouhui.top/%E6%B3%A8%E5%86%8C%E5%8D%8F%E8%AE%AE%E6%9D%A1%E4%BE%8B.docx");
		},
		// 注册接口
		// /hq/webPage/createWebUser
	},
};
</script>

<style scoped lang="scss">
::v-deep .ant-form label {
	font-size: 16px;
}
.page {
	min-width: 1150px;
	height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.content {
	margin-top: 34px;
	flex-shrink: 0;
	width: 1150px;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-bottom: 30px;
}
.goBack {
	width: 100%;
	.goBack-btn {
		cursor: pointer;
		font-size: 28px;
	}
	.goBack-btn:hover {
		position: relative;
		&::before {
			content: "";
			position: absolute;
			bottom: -1px;
			height: 1px;
			width: 100%;
			background: #333333;
		}
	}
}

.nav {
	margin-top: 38px;
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	.nav-item {
		width: 320px;
		height: 60px;
		background: rgb(8, 124, 232, 0.1);
		font-size: 28px;
		font-weight: 500;
		color: #087ce8;
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		line-height: 60px;
		cursor: pointer;
	}
	.nav-select {
		background: #087ce8;
		color: #ffffff;
	}
}
.form {
	margin-top: 70px;
	width: 500px;
}

.register-success {
	margin-top: 180px;
	display: flex;
	flex-direction: row;
	align-items: center;
	font-size: 56px;
	font-weight: bold;
	color: #1f82e2;
}

.inputContent {
	position: relative;
	.dataSourse {
		position: absolute;
		top: 42px;
		left: 0;
		width: 100%;
		border-radius: 4px;
		border: 1px solid rgb(51, 51, 51, 0.5);
		z-index: 999;
		background: #fff;
		.dataSourse-option {
			box-sizing: border-box;
			height: 40px;
			width: 100%;
			font-size: 14px;
			color: #333333;
			padding: 0 10px;
			line-height: 40px;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			user-select: none;
			cursor: pointer;
		}
		.dataSourse-option:hover {
			color: rgb(24, 144, 255, 0.8);
		}
	}
}

.uploadImg {
	max-height: 400px;
	max-width: 320px;
}

.File {
	&:hover {
		color: rgb(24, 144, 255, 0.8);
	}
}
</style>
